import { Component } from '@angular/core';
import { DividerModule } from "primeng/divider";
import { RouterLink } from '@angular/router';

/**
 * Component displaying the public privacy policy
 *
 * @author Dan Bennett
 */
@Component({
    selector: 'app-privacy-policy',
    imports: [
        DividerModule,
        RouterLink
    ],
    templateUrl: './privacy-policy.component.html',
    styleUrl: './privacy-policy.component.sass'
})
export class PrivacyPolicyComponent {

}
